import { makeStyles } from "@material-ui/core/styles";
import { MuiTheme } from "theme";

interface IStylesProps {
  textareaFontSize: number;
}

export default makeStyles<MuiTheme, IStylesProps>((theme: MuiTheme) => {
  const { primary } = theme.palette;

  return {
    header: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      fontSize: ({ textareaFontSize }) => textareaFontSize || 12,
      minHeight: 29,
      color: primary.dark,
      position: "relative"
    },
    headerContent: {
      display: "flex"
    },
    loader: {
      display: "inline-flex",
      padding: 0,
      width: 30
    },
    optional: {
      opacity: 0.5
    }
  };
});
